<template>
	<div class='form'>
		<Form :model="contact" :label-position='"top"' ref='contactForm' :rules='rules'>
			<FormItem>
                <RadioGroup v-model="contact.hasPcNo">
                    <Radio size='large' label="0">
                        <span>我已有顧客編號</span>
                    </Radio>
                    <Radio size='large' label="1">
                        <span>我還冇顧客編號</span>
                    </Radio>
                </RadioGroup>
            </FormItem>
            <FormItem v-if='contact.hasPcNo == 0' label='顧客編號' prop='Vipno'>
            	<Input size='large' v-model='contact.Vipno' placeholder='顧客編號'></Input>
            </FormItem>
            <FormItem label='姓名' prop='UserName'>
            	<Input size='large' v-model='contact.UserName' placeholder='用戶姓名'></Input>
            </FormItem>
            <FormItem label='電子郵件' prop='Email'>
            	<Input size='large' v-model='contact.Email' placeholder='電子郵件'></Input>
            </FormItem>
            <FormItem label='電話' prop='MobilePhone'>
            	<Input size='large' v-model='contact.MobilePhone' placeholder='電話'></Input>
            </FormItem>
            <FormItem label='問題類型' prop='QuestionType'>
            	<Select v-model='contact.QuestionType' size='large' placeholder='請選擇問題類型' filterable>
            		<Option v-for='option in options' :value='option.value' :key='option.value' :label='option.label'> </Option>
            	</Select>
            </FormItem>
            <FormItem label='問題' prop='Question'>
            	<Input size='large' type='textarea' v-model='contact.Question' placeholder='問題描述'></Input>
            </FormItem>
            <FormItem v-if='contact.hasPcNo == 0' label='附件'>
				<imageUpload style='background: #eee;' :loading='imageLoading' @select='selectCard' :type='"QuestionImg"'  :image='contact.QuestionImg'></imageUpload>
				<p class="error" style="text-align: center;">{{upload_error}}</p>
            </FormItem>
            <FormItem>
            	<div style="text-align: center;">
            		<Button style='width: 200px;' type='primary' size='large' @click='submit'>提交</Button>
            	</div>
            	
            </FormItem>
		</Form>
	</div>
</template>

<script>
	import {RE_PCNO,RE_PHONE,RE_EMAIL} from '@/components/common/regex'
	import imageUpload from '@/components/common/imageUpload'
	import {formValid} from '@/components/common/mixin';
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
				contact:{
					hasPcNo:'0',
					Vipno:null,
					UserName:null,
					Email:null,
					MobilePhone:null,
					QuestionType:null,
					Question:null,
					QuestionImg:null,
					type:null,
					Isprocess:0,
				},
				imageLoading:false,
				upload_error:null,
				rules:{
					Vipno:[
						{required: true,message: '這是必填項', trigger: 'blur'},
						{type:'string',message:'無效的顧客編號',trigger: 'blur',pattern:RE_PCNO},
					],
					UserName:[
						{required: true,message: '這是必填項', trigger: 'blur'},
					],
					Email:[
						{required: true,message: '這是必填項', trigger: 'blur'},
						{type:'string',message:'郵箱格式不正確',trigger: 'blur',pattern:RE_EMAIL},
					],
					MobilePhone:[
						{required: true,message: '這是必填項', trigger: 'blur'},
						{type:'string',message:'請輸入正確的中國大陸11位手機號碼',trigger: 'blur',pattern:RE_PHONE},
					],
					QuestionType:[
						{required: true,message: '這是必選項', trigger: 'change'},
					],
					Question:[
						{required: true,message: '這是必填項', trigger: 'blur'},
					],
				}
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[formValid],
		components: {
			imageUpload,
		},
		computed: {
			...mapState({

			}),
			options(){
				if (this.contact.hasPcNo == 0) {
					return [{value:'1',label:'信息谘詢',},{value:'2',label:'網站資料修改',},{value:'3',label:'産品谘詢',},{value:'4',label:'開發票',},{value:'5',label:'售後服務',},{value:'6',label:'違規舉報',},]
				} else {
					return [{value:'7',label:'新用戶谘詢',}]
				}
				
			}
		},
		methods: {
			...mapActions([
				'postFeedbackAction',
				'loadFileAction',
				'uploadImageAction',
			]),
			async initData(){

			},
			isValid(item){
				let now = new Date
				let valid = true
				if (item.validFrom) {
					valid = now >= item.validFrom
				}
				if (item.validTo) {
					valid = now <= item.validTo
				}
				return valid
			},
			async selectCard(value, file){
				this.imageLoading = true;
				var type=file.name.split('.')[1];
                let response = await this.uploadImageAction({file,module:'Feedback'});
                this.imageLoading = false;
                if (response.success) {
					this.contact.QuestionImg = response.value;
					this.contact.type=type;
                }else {
                	this.upload_error = '圖片上傳失敗'
                }
			},
			async submit(){
				console.log(this.contact)
				let valid = await this.validate('contactForm');
				if (valid) {
					let response = await this.postFeedbackAction(this.contact)
					if (response.Code == 1) {
						this.$Modal.success({
							title:'提交問題',
							content:'問題提交成功',
							onOk:()=>{
								this.$router.push('/home')
							}
						})
					}else {
						this.$Modal.error({
							title:'提交問題',
							content:response.msg,
						})
					}
				}
			}
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/mixin';
	@import '@/style/common';
	.form {
		padding: 0 20px;
	}
	.img-responsive {
	    display: block;
	    max-width: 100%;
	    height: auto;
	}
	.en {
		@include fontSize($font-size-12);
	}
	.error {
		// position:absolute;
		top:28px;
		color: red;
	}
	
</style>